import React from 'react';

import { CursorRectangleSelection01FreeIcons } from '@hugeicons/core-free-icons/index';

export function getTextWithReferences(text, candidate_name = null, answers = [], params = []) {
  if (!text) return;
  if (typeof text !== 'string') return text;

  const textWithLinks = text?.replace(/\[((?!\]).)*\]\(((?!\)).)*\)/g, function (match) {
    const [, text] = /\[([^)]+)\]/.exec(match);
    const [, link] = /\(([^)]+)\)/.exec(match);

    return `[_${text}_${link}]`;
  });

  const textWithVars = textWithLinks.replace(/{{((?!}).)*}}/g, function (match) {
    var m = match.replace(/[{}]/g, '');
    if (m === 'candidate' && candidate_name) {
      return `[${candidate_name}]`;
    } else if (isNaN(m)) {
      if (params[m]) {
        return `[${params[m]}]`;
      } else {
        return `[${m}]`;
      }
    } else {
      if (answers[m]) return `[${answers[m]}]`;
      else return `[Q${m} answer]`;
    }
  });

  return makeHighlights(textWithVars);
}

export function makeHighlights(text) {
  let text_array = text.split(/\[|\]/);
  let text_highlighted = [];
  for (let i = 0; i < text_array.length; i++) {
    if (i % 2 === 0) {
      text_highlighted.push(text_array[i]);
    } else if (text_array[i][0] === '_') {
      const [, text, link] = text_array[i].split('_');
      text_highlighted.push(
        <a key={i} href={link} target="_blank">
          {text}
        </a>,
      );
    } else {
      text_highlighted.push(
        <span key={i} className="highlight-reference">
          {text_array[i]}
        </span>,
      );
    }
  }
  return text_highlighted;
}

// Custom forms version (can match any variable)
export const textWithReferences = (text, variables = {}) => {
  if (!text) return;
  if (typeof text !== 'string') return text;

  const textWithLinks = text?.replace(/\[((?!\]).)*\]\(((?!\)).)*\)/g, match => {
    const [, text] = /\[([^)]+)\]/.exec(match);
    const [, link] = /\(([^)]+)\)/.exec(match);

    return `<a href="${link}" target="_blank">${text}</a>`;
  });

  const textWithVars = textWithLinks?.replace(/{{([^}]+)}}/g, function (match, variableContent) {
    let variableName = variableContent;

    if (variableContent.includes('<')) {
      variableName = variableContent
        .replace(/<[^>]*>/g, '') // Remove all HTML tags
        .replace(/&nbsp;/g, ' ') // Replace &nbsp; with space
        .replace(/&amp;/g, '&') // Replace &amp; with &
        .replace(/&lt;/g, '<') // Replace &lt; with <
        .replace(/&gt;/g, '>') // Replace &gt; with >
        .replace(/&quot;/g, '"') // Replace &quot; with "
        .replace(/&#39;/g, "'") // Replace &#39; with '
        .replace(/\s+/g, ' '); // Normalize multiple spaces to single space
    }

    variableName = variableName.trim();

    const value = variables[variableName];
    return value ? value : variableName;
  });

  return textWithVars;
};

export function getAffectedLogicJumps(logicJumps, currentOrder, targetOrder) {
  const safeLogicJumps = logicJumps || [];

  const logicJumpsAttached = safeLogicJumps.filter(({ from, to }) => {
    const jumpStart = Math.min(from, to);
    const jumpEnd = Math.max(from, to);

    const surroundsMove =
      jumpStart < targetOrder &&
      jumpStart < currentOrder &&
      jumpEnd > targetOrder &&
      jumpEnd > currentOrder;

    if (surroundsMove) return false;

    const isDirectlyConnected =
      from === currentOrder || to === currentOrder || from === targetOrder || to === targetOrder;

    const isSpanningJump = jumpStart < targetOrder && jumpEnd > targetOrder;

    return isDirectlyConnected || isSpanningJump;
  });

  return logicJumpsAttached;
}

export function getLogicJumpsForField(logicJumps, fieldOrder) {
  const logicJumpsAttached = (logicJumps || []).filter(
    ({ from, to }) => from === fieldOrder || to === fieldOrder,
  );
  return logicJumpsAttached;
}

export function createLogicJumpsMessage(logicJumpsAttached) {
  return logicJumpsAttached
    .map(jump => {
      return `Field <b>${jump.from}</b> logic jumps to field <b>${jump.to}</b>`;
    })
    .join('<br/>');
}
